var render = function render(){var _vm=this,_c=_vm._self._c;return (
    _vm.params.value == 'hide' ||
     _vm.isRoleLower
  )?_c('div'):_c('div',[(_vm.params.value && _vm.params.value.can_delete)?_c('img',{staticStyle:{"cursor":"pointer"},attrs:{"data-toggle":"modal","data-target":"#exampleModal","src":require("@/assets/delete_bin.svg")},on:{"click":function($event){return _vm.showDelete(_vm.params.value)}}}):_c('img',{staticClass:"disabledBin",attrs:{"src":require("@/assets/delete_bin_disabled.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }